/**
 * PromoTix primary API `event_type_id` → display name (from public `all_events` payloads).
 * Use `SHARETRIBE_ENUM_OPTION_TO_EVENT_TYPE_ID` below to align Search filters with these ids.
 */
export const PROMOTIX_EVENT_TYPE_CATALOG = {
  1: 'Auto, Boat & Air',
  2: 'Business & Professional',
  3: 'Charity & Causes',
  4: 'Community & Culture',
  5: 'Family & Education',
  6: 'Fashion & Beauty',
  7: 'Film, Media & Entertainment',
  8: 'Food & Drink',
  9: 'Government & Politics',
  10: 'Health & Wellness',
  11: 'Hobbies & Special Interest',
  12: 'Home & Lifestyle',
  13: 'Music',
  14: 'Other',
  15: 'Performing & Visual Arts',
  16: 'Religion & Sprituality',
  17: 'Science & Technology',
  18: 'Seasonal & Holiday',
  19: 'Sport & Fitness',
  20: 'Travel & Outdoor',
};

/**
 * Sharetribe Console listing field: use **Option value** (e.g. `Auto-Boat-air`), not the display
 * “Option name”. That value is stored on the listing and appears in Search URLs as `pub_<fieldKey>`.
 *
 * Set `PRIMARY_EVENT_SHARETRIBE_ENUM_PUBLIC_DATA_KEY` to the field’s **schema key** from Console
 * (same as `publicData.<key>` without the `pub_` prefix). Example: key `eventCategory` → URL
 * `?pub_eventCategory=Auto-Boat-air`.
 */
export const PRIMARY_EVENT_SHARETRIBE_ENUM_PUBLIC_DATA_KEY = null;

/**
 * Map each Sharetribe enum **Option value** → PromoTix `event_type_id` (number).
 * Fill all rows using Console “Field options” → Option value column, aligned with
 * `PROMOTIX_EVENT_TYPE_CATALOG`.
 */
export const SHARETRIBE_ENUM_OPTION_TO_EVENT_TYPE_ID = {
  'Auto-Boat-air': 1,
  'business-professional': 2,
  'charity-causes': 3,
  'community-culture': 4,
  'family-education': 5,
  'fashion-beauty': 6,
  'film-media-entertainment': 7,
  'food-drink': 8,
  'government-politics': 9,
  'health-wellness': 10,
  'hobbies-special-interest': 11,
  'home-lifestyle': 12,
  'music': 13,
  'other': 14,
  'performing-visual-arts': 15,
  'religion-spirituality': 16,
  'science-technology': 17,
  'seasonal-holiday': 18,
  'sport-fitness': 19,
  'travel-outdoor': 20,
  // Example — add the other 19 Option values from Sharetribe Console, e.g.:
  // 'Business-Professional': 2,
  // 'Music': 13,
};

/**
 * Map Sharetribe **listing process** `publicData.listingType` (search param `pub_listingType`)
 * to PromoTix `event_type_id`. Use this when your filter is listing type, not the 20-category enum.
 *
 * Resolution order in `primaryEventsQuery`: explicit `event_type_id` URL param → enum field above
 * (if key is set) → this map for `pub_listingType`.
 */
export const LISTING_TYPE_TO_EVENT_TYPE_ID = {
  // Example:
  // 'music-resale': 13,
};
